import {useState} from 'react';
import * as S from './SimilarHotelAmenities.styles';

// COMPONENTS
import AmenitiesIconSelector from '../../../../../../shared/components/AmenitiesIconSelector';

const SimilarHotelAmenities: React.FC<{
  amenitiesList: string[];
}> = ({amenitiesList = []}) => {
  return (
    <S.HotelAmenitiesWrapOuterDiv>
      {amenitiesList?.map(amenityName => {
        return (
          <S.AmenityContainer key={amenityName}>
            <S.IconContainer>
              <AmenitiesIconSelector
                name={amenityName}
                styleProps={{
                  width: '1.5rem',
                  height: '1.5rem',
                }}
              />
            </S.IconContainer>
            {amenityName}
          </S.AmenityContainer>
        );
      })}
    </S.HotelAmenitiesWrapOuterDiv>
  );
};

export default SimilarHotelAmenities;
